module.exports = __webpack_public_path__ + "img/WA0000.21248881.jpg";